<template>
  <div class='container' style='background-color: #FFFFFF'>
    <div class='col-md-12'>
      <div class='personal-info mt-5'>
        <div v-for='personalInfo in personalInfo' :key='personalInfo.user_code'>
          <div class='row'>
            <div class='col-md-1'>
              <div v-if='personalInfo.picture'>
                <img :src='personalInfo.picture' class='rounded-circle float-none partner-image'
                     alt='Cinque Terre'>
              </div>
              <div v-else>'
                <img src='@/assets/shuttle_logo_ft.png' class='rounded-circle float-none partner-image'>
              </div>
            </div>
            <div class='col-md-4'>
              <h3>{{ personalInfo.name }}</h3>
              <br>
              <h3><span class='badge bg-secondary'
                        style='border-radius: 23px;'>{{ personalInfo.status ? personalInfo.status : 'Null'
                }}</span>
              </h3>
            </div>
            <div class='col-md-7'>
              <article><i class='bi bi-telephone'>&nbsp;&nbsp; {{ personalInfo.mobile ? personalInfo.mobile : 'N/A'
                }}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                class='bi bi-envelope'>&nbsp;&nbsp; {{ personalInfo.email ? personalInfo.email : 'N/A' }}</i></article>
              <article><i class='bi bi-geo-alt'>&nbsp;&nbsp; {{ personalInfo.address ? personalInfo.address : 'N/A'
                }}</i>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import http from '../../config/axios';
import userService from '../../config/axiosUserService';

export default {
  name: 'PersonalInfo',
  data() {
    return {
      personalInfo: []
      // partnerDocument: []
    };
  },
  mounted() {
    this.getPersonalInformation();
    // this.getVehicleInformation();
  },
  methods: {
    getPersonalInformation() {
      // http.get('v3/partners/' + `${this.$route.params.id}`)
      userService.get(`v1/users?user_code=${this.$route.params.id}&fields=name,mobile,user_code,status,picture,address,email`)
        .then(
          response => this.personalInfo = response.data.data
        )
        .catch(error => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    }
    // getVehicleInformation() {
    //   http.get('v3/partners/' + `${this.$route.params.id}` + '/documents')
    //     .then(response => {
    //       this.partnerDocument = response.data.data;
    //     })
    //     .catch(error => {
    //       this.errorMessage = error.message;
    //       console.error('There was an error!', error);
    //     });
    // }
  }
};
</script>

<style scoped>
.partner-image {
  Width: 48px;
  Height: 48px;
}

.personal-info h3 {
  position: absolute;
  font-family: Montserrat;
  font-weight: bold;
  font-size: 18px;
  line-height: 14px;
}

.personal-info article i {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 12px;
  color: #555555;
}
</style>